// ...existing code...
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export let environment = {
  name: 'kubernetes',
  production: false,
  version: env.npm_package_version,
  serverUrl: '',
  oauth: {
    enabled: true,  // For connecting to Mifos X using OAuth2 Authentication change the value to true
    serverUrl: (window as any)?.env?.keycloakBaseUrl || 'https://accounts.oneacrefund.org',
    realm: (window as any)?.env?.keycloakRealm || 'OneAcreFund',
    client_id: (window as any)?.env?.keycloakClientId || 'paymenthub',
    tokenUrl: (window as any)?.env?.tokenUrl || `https://accounts.oneacrefund.org/auth/realms/OneAcreFund/protocol/openid-connect/token`,
    redirectUri: (window as any)?.env?.redirectUri || 'https://ph-web.oneacrefund.org/home'
  },
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'fr-FR'],
  externalConfigurationFile: 'configuration.properties', // When provided, the external configuration file content will override this environment settings based on naming conventions
  auth: {
    enabled: false,
    tenant: 'oaf',
  },

  amsShortCodes: [
    {
      option: 'ERPLY_TILL',
      type: 'TILL',
      value: '9499081',
    },
    {
      option: 'TUPANDE_TILL',
      type: 'TILL',
      value: '6064956',
    },
    {
      option: 'PAYGOPS_USSD_KE_TILL',
      type: 'TILL',
      value: '9347335',
    },
    {
      option: 'ROSTER_USSD_KE_TILL',
      type: 'TILL',
      value: '9558723',
    },
    {
      option: 'ODOO_KE_TILL',
      type: 'TILL',
      value: '9491775',
    },
    {
      option: 'FINERACT_USSD_KE_TILL',
      type: 'TILL',
      value: '8167094',
    },
    {
      option: 'FINERACT_KE_PAYBILL',
      type: 'PAYBILL',
      value: '840706',
    },
    {
      option: 'TEST_PAYBILL',
      type: 'PAYBILL',
      value: '840700',
    },
  ],
  matomo: {
    url: 'https://analytics.oneacrefund.org',
    siteId: 18, // Replace with your site ID
    disabled: false,
  },
  sentry: {
    dsn: (window as any)?.env?.sentryDsn || 'https://2eb6c3967dc4586bda6f9cd5f8d15ba4@o454511.ingest.us.sentry.io/4509881008455680', // Add your Sentry DSN here for production
    enabled: true, // Enable Sentry in production
    environment: 'production',
  },
  TENANTS: ['oaf', 'kenya', 'rwanda', 'burundi', 'malawi', 'usa', 'zambia', 'nigeria'],
};
